<template>
  <router-view />
</template>

<script>
export default {
  name: 'Pay'
  // child's container
}
</script>



// WEBPACK FOOTER //
// src/views/Pay/Pay.vue